export const MEDIA = Object.freeze({
  loadingIsland: './media/v1/trading-post-loading-island.webp',
  panorama: './media/v1/trading-post-panorama.webp',
  riverMotion: './media/v1/scene-river-motion-a7420901.webp',
  skySunrise: './media/v1/scene-sky-sunrise-1107ff11.webp',
  skySunset: './media/v1/scene-sky-sunset-219d314b.webp',
  skyNight: './media/v1/scene-sky-night-8a22954a.webp',
  skyStorm: './media/v1/scene-sky-storm-bff9a901.webp',
  starGlints: './media/v1/scene-star-glints-547e660b.webp',
  rainCurtain: './media/v1/scene-rain-curtain-c7587b54.webp',
  ledger: './media/v1/ledger-map-background.webp',
  vessels: './media/v1/river-vessels-atlas.webp',
  road: './media/v1/road-traffic-atlas.webp',
  settlerWagonBody: './media/v1/settler-wagon-body-cutout-generated-v3.webp',
  settlerWagonWheelA: './media/v1/settler-wagon-wheel-a-cutout-generated-v3.webp',
  settlerWagonWheelB: './media/v1/settler-wagon-wheel-b-cutout-generated-v3.webp',
  facilities: './media/v1/facilities-atlas-alpha.webp',
  accessories: './media/v1/accessories-atlas-alpha.webp',
  vendorPortraits: './media/v1/vendor-portraits-atlas.webp',
  vendorPortraitsA: './media/v1/vendor-portraits-atlas-a.webp',
  vendorPortraitsB: './media/v1/vendor-portraits-atlas-b.webp',
  vendorPortraitsC: './media/v1/vendor-portraits-atlas-c.webp',
  vendorPortraitsD: './media/v1/vendor-portraits-atlas-d.webp',
  vendorPortraitsE: './media/v1/vendor-portraits-atlas-e.webp',
  vendorPortraitsF: './media/v1/vendor-portraits-atlas-f.webp',
  propertyOverlays: './media/v1/property-horticulture-atlas-alpha.webp',
  horticultureLifecycle: './media/v1/horticulture-lifecycle-windmill-atlas-46941daf.webp',
  workingWindmill: './media/v1/working-windmill-body-rotor-atlas-e414e591.webp',
  shopInterior: './media/v1/shop-interior-empty-v2-7b3b2f86.webp',
  shopInteriorGeneral: './media/v1/shop-interior-general-store-4edb6688.webp',
  shopInteriorEmporium: './media/v1/shop-interior-emporium-5765e56a.webp',
  shopInteriorTradingHouse: './media/v1/shop-interior-trading-house-2e2c4724.webp',
  shopGoods: './media/v1/shop-goods-atlas-v2-e8e49ea7.webp',
  potteryProducts: './media/v1/pottery-products-atlas-fc229487.webp',
  horseStock: './media/v1/horse-stock-atlas-3b9e1ab4.webp',
  artworkStock: './media/v1/artwork-stock-atlas-984287f9.webp',
  interiorPotteryBeginner: './media/v1/interior-pottery-beginner-722de65e.webp',
  interiorPotteryIntermediate: './media/v1/interior-pottery-intermediate-c09d13ac.webp',
  interiorPotteryComplete: './media/v1/interior-pottery-complete-7a1d0e70.webp',
  interiorLiveryBeginner: './media/v1/interior-livery-beginner-c40b18fe.webp',
  interiorLiveryIntermediate: './media/v1/interior-livery-intermediate-9d351c4c.webp',
  interiorLiveryComplete: './media/v1/interior-livery-complete-b106b153.webp',
  interiorGalleryBeginner: './media/v1/interior-gallery-beginner-447c99a0.webp',
  interiorGalleryIntermediate: './media/v1/interior-gallery-intermediate-007da2fe.webp',
  interiorGalleryComplete: './media/v1/interior-gallery-complete-2ff52fcf.webp',
  interiorShipwrightBeginner: './media/v1/interior-shipwright-beginner-290de845.webp',
  interiorShipwrightIntermediate: './media/v1/interior-shipwright-intermediate-89fef031.webp',
  interiorShipwrightComplete: './media/v1/interior-shipwright-complete-ff42cde1.webp',
  interiorRepairBeginner: './media/v1/interior-repair-beginner-cf4ab021.webp',
  interiorRepairIntermediate: './media/v1/interior-repair-intermediate-62c50989.webp',
  interiorRepairComplete: './media/v1/interior-repair-complete-3c8d72fe.webp',
  interiorCasinoBeginner: './media/v1/interior-casino-beginner-f56f4f34.webp',
  interiorCasinoIntermediate: './media/v1/interior-casino-intermediate-c7605f58.webp',
  interiorCasinoComplete: './media/v1/interior-casino-complete-ad01e7fd.webp',
});

export function vendorPortraitUrl(portrait = {}) {
  const id = String(portrait.atlasId || '').replace(/^vendor-portraits-atlas-?/, '').toUpperCase();
  return MEDIA[`vendorPortraits${id}`] || MEDIA.vendorPortraits;
}

// Native atlas geometry, not the height of the surrounding conversation, sets
// each face's proportions. Keep this outside save data for older characters.
export function vendorPortraitAspect(portrait = {}) {
  const id = String(portrait.atlasId || '').replace(/^vendor-portraits-atlas-?/, '').toLowerCase();
  const [width, height] = ({ a: [1536, 1024], b: [1448, 1086], c: [1448, 1086], d: [1448, 1086], e: [1448, 1086], f: [1536, 1024] })[id] || [1024, 1024];
  return (width * (portrait.rows || 4)) / (height * (portrait.columns || 4));
}

export const VESSEL_FRAMES = Object.freeze({
  'trapper-canoe': 0,
  'fishing-skiff': 1,
  'log-raft': 2,
  flatboat: 3,
  keelboat: 4,
  'survey-cutter': 6,
  'freight-barge': 7,
  'packet-steamer': 8,
  'luxury-steamer': 9,
  showboat: 10,
  'gaming-steamer': 10,
});

export const ROAD_FRAMES = Object.freeze({
  'trapper-walker': 0,
  'unhoused-traveler': 2,
  'settler-wagon': 6,
  peddler: 5,
  caravan: 11,
  stagecoach: 8,
  drovers: 10,
  'survey-crew': 3,
  'mail-coach': 9,
  'tour-party': 4,
});

export const FACILITY_FRAMES = Object.freeze({
  'shop-shack': 0,
  'shop-general': 0,
  'shop-emporium': 1,
  'shop-trading-house': 2,
  'wild-landing': 3,
  'marked-trail': 3,
  campground: 3,
  'riverside-preserve': 3,
  'canoe-landing': 3,
  wharf: 3,
  'ferry-office': 3,
  'steamboat-dock': 4,
  inn: 1,
  'boarding-house': 1,
  hotel: 2,
  livery: 5,
  'coach-depot': 6,
  'repair-workshop': 7,
  shipwright: 8,
  'meeting-house': 9,
  'public-hall': 9,
  'post-office': 6,
  schoolhouse: 9,
  clinic: 1,
  'grain-mill': 7,
  'art-gallery': 10,
  'botanical-conservatory': 1,
  bathhouse: 1,
  'bank-assay-office': 6,
  'opera-room': 10,
  'photography-studio': 6,
  'town-museum': 9,
  theater: 10,
  warehouse: 11,
  'ice-house': 11,
  'freight-office': 11,
  'meal-house': 9,
});

export const HORTICULTURE_FRAMES = Object.freeze({
  'apple-orchard': 8,
  'medicinal-herb-garden': 9,
  'cold-frame': 10,
  'kitchen-garden': 9,
  'berry-trellis': 12,
  apiary: 13,
  'tree-nursery': 14,
  'market-greenhouse': 10,
  'heritage-apple-tree': 8,
});

export const DAMAGE_FRAMES = Object.freeze({
  'boarded-window': 0,
  'shattered-window': 1,
  'fire-scorch': 2,
  'damaged-awning': 3,
  'roof-tarp': 4,
  rubble: 5,
  'water-damage': 6,
  'broken-door': 7,
});

export const ACCESSORY_FRAMES = Object.freeze({
  fountain: 0,
  gazebo: 1,
  well: 2,
  'wayfinding-post': 3,
  'shade-tree': 4,
  'flower-garden': 5,
  'vegetable-garden': 6,
  'split-rail-fence': 7,
  bench: 8,
  'street-lantern': 9,
  'barrel-stack': 10,
  'hitching-post': 11,
  handcart: 12,
  'cargo-crane': 13,
  'canvas-camp': 14,
  'public-shelter': 15,
  'canoe-rack': 3,
  'flower-boxes': 5,
  'town-clock-sign': 3,
  bandstand: 1,
  'civic-fountain': 0,
  'riverside-gazebo': 1,
  'shelter-meal-house': 15,
  'water-well': 2,
  'wayfinding-post': 3,
  'flower-garden': 5,
  'vegetable-garden': 6,
  'wood-bench': 8,
  handcart: 12,
  'canvas-camp': 14,
  'notice-board': 15,
  'stone-path': 7,
  'rain-barrels': 10,
  'decorative-urns': 0,
  'mooring-bollards': 11,
  woodpile: 10,
  flagpole: 3,
  'wash-line': 7,
  sawhorses: 13,
});

export function spritePosition(index, columns) {
  const x = index % columns;
  const y = Math.floor(index / columns);
  return `${(x / (columns - 1)) * 100}% ${(y / (Math.ceil((index + 1) / columns) > 1 ? 2 : 1)) * 100}%`;
}
